import { ServiceRepository } from '@/core/service/domain/ServiceRepository.ts'
import { MarketServicesClient } from 'online-customer-services-ts'
import { Service } from '@/core/service/domain/Service.ts'
import { useTranslator } from 'sima-suite-translator-vue3'

export class ServiceRepositoryBackendClient implements ServiceRepository {
  private readonly serviceClient: MarketServicesClient

  constructor(url: string) {
    this.serviceClient = new MarketServicesClient(url)
  }

  async getServices(hostId: string): Promise<Service[]> {
    const { language } = useTranslator()
    const services = await this.serviceClient.getMarketServices(hostId, language.value)

    return services.map((service) => ({
      id: service.id?.toString() ?? '',
      name: service.name ?? '',
      remarks: '',
      hasRemarks: service.hasRemarks ?? false,
      isSelected: false
    }))
  }
}
